import _ from 'lodash';
import angular from 'angular';

angular.module('notifications')

    .controller("searchPersonsModalCtrl", ['uiGridSelectionService', '$state', '$timeout', 'LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', '$uibModal', 'options', '$rootScope', 'logService',
        function (uiGridSelectionService, $state, $timeout, LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, $uibModal, options, $rootScope, logService) {
        logService.debug($state.current.name);
        if ($state.current.name === "notifications.list" || $state.current.name === "correspondence.edit") {
            $scope.eventId = null;
        } else {
            $scope.eventId = $stateParams.id;
        }
        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = true;

        $scope.showError = false;
        $scope.selectedRows = [];
        $scope.options = [];
        $scope.showResults = false;
        $scope.personPositionModal = {};
        $scope.personPositionOrigin = {};
        $scope.personPositionModal.persons_groups = {};
        $scope.personPositionModal.FK_positions_groups = null;
        $scope.type_persons = [
            { option: null, label: $filter('translate')('persons.title_all'), checked: true },
            { option: "authority", label: $filter('translate')('persons.title'), checked: false }
        ];
        $scope.typePersonSelected = { checked: $scope.type_persons[0].option };

        if ($scope.personPositionModal.position_order == 0) $scope.personPositionModal.position_order = null;
        // funci�n que monta al estructura del select.
        $scope.groupTree = function (groups, locationListResult, parent_id, levelString) {

            for (var i = 0; i < groups.length; i++) {
                angular.forEach(groups[i].FK_groups_groups_groups1, function (group_group) {
                    if (group_group.parent_group_id == parent_id) {
                        groups[i].name = levelString + groups[i].name;
                        locationListResult.push(groups[i]);
                        $scope.groupTree(groups, locationListResult, groups[i].id, levelString + "----");
                        if (!_.some(groups[i].FK_positions_groups, function (position) { return position.id == ""; })) // si no est� s�lo
                            groups[i].FK_positions_groups.push({ id: "", name: $filter('translate')('events.guests.all_positions') })
                    }
                });
            }
        }

        //Custom function.  return null values instead of undefined
        function isDefinedAndNotNull(val) {
            return angular.isDefined(val) && val !== null;
        }

        $http({
            method: 'get',
            url: (window as any).CONFIG.api_url + '/Groups/GetGroupsPositions',
            params: options
        }).then(function (results, status, headers, config) {
            var groups = results.data.rows;
            let groupsListResult: any[] = [];
            groupsListResult.push({
                id: "",
                name: $filter('translate')('events.guests.all_groups'),
                FK_positions_groups: [{ id: "", name: "" }]
            });
            for (var i = 0; i < groups.length; i++) {
                if (groups[i].FK_groups_groups_groups1.length == 0) {
                    groupsListResult.push(groups[i]);
                    $scope.groupTree(groups, groupsListResult, groups[i].id, "----");
                    groups[i].FK_positions_groups.push({ id: "", name: $filter('translate')('events.guests.all_positions') });
                }
            }
            $scope.personGroups = groupsListResult;
            $scope.$watch('personPositionModal.persons_groups.selected', function (newValue, oldValue) {
                if (angular.isDefined(oldValue) && newValue.id != oldValue.id) {
                    if ($scope.personPositionModal.FK_positions_groups != null && angular.isDefined($scope.personPositionModal.FK_positions_groups.selected)) $scope.personPositionModal.FK_positions_groups.selected = "";
                }
            });
        });


        $scope.searchGuestsOptions = function () {
            $scope.selectedRows = [];
            //gridGuestsOptions;
            $scope.showResults = true;
            if (!isDefinedAndNotNull($scope.personPositionModal.FK_positions_groups)) {
                $scope.group_id = "";
                $scope.position_id = "";
            } else {
                $scope.position_id = $scope.personPositionModal.FK_positions_groups.selected.id;
            }
            if (angular.isDefined($scope.personPositionModal.persons_groups.selected)) $scope.group_id = $scope.personPositionModal.persons_groups.selected.id;

            if (!angular.isDefined($scope.search)) {
                $scope.search = {};
                $scope.search.name = "";
                $scope.search.surname = "";
                $scope.search.lastname = "";
                $scope.search.historic_position = false;
            }

            if (angular.isDefined($scope.gridGuestsOptions)) {
                $scope.gridGuestsOptions.loadData(false);
                //quitamos la seleccion
                //$scope.gridGuestsOptions.gridApi.selection.clearSelectedRows();
            } else {
                $scope.gridGuestsOptions = {
                    exporterMenuCsv: false,
                    enableGridMenu: true,
                    enableHiding: false,
                    enableSelectionBatchEvent: true,//para obtener los seleccionados
                    gridMenuShowHideColumns: false,
                    paginationPageSizes: [5, 10, 25],
                    paginationPageSize: 5,
                    onRegisterApi: function (gridApi) {
                        this.gridApi = gridApi;
                        this.gridApi.core.on.rowsRendered($scope, callbackFunctionItemChange);
                        this.gridApi.selection.on.rowSelectionChanged($scope, callbackFunctionRowSelected);
                        this.gridApi.selection.on.rowSelectionChangedBatch($scope, callbackFunctionRowSelected);

                    },
                    columnDefs: [
                        { name: 'id', visible: false, enableFiltering: false, enableHiding: false, exporterSuppressExport: true },
                        { name: 'positionId', visible: false, enableFiltering: false, enableHiding: false, exporterSuppressExport: true },

                        {
                            field: 'photo', nableFiltering: false, enableSorting: false,
                            displayName: $filter('translate')('persons.photo'), cellTemplate: "<img width=\"30px\" ng-show=\"grid.getCellValue(row, col)\"  ng-src=\"{{grid.getCellValue(row, col)}}\" style=\"margin-left:10px;margin-top:5px;\" lazy-src>", width: 70, enableFiltering: false
                        },
                        { name: 'program_emails', displayName: $filter('translate')('person.mail'), enableFiltering: true, enableSorting: true, enableHiding: false },
                        { name: 'name', displayName: $filter('translate')('persons.name'), enableFiltering: true, enableSorting: true, enableHiding: false },
                        { name: 'surname', displayName: $filter('translate')('persons.surname'), enableFiltering: true, enableSorting: true, enableHiding: false },
                        { name: 'lastname', displayName: $filter('translate')('persons.lastname'), enableFiltering: true, enableSorting: true, enableHiding: false }
                    ],
                    getData: function (options) {
                        logService.debug(options)
                        var deferred = $q.defer();
                        options.event_id = $scope.eventId,
                        options.group_id = $scope.group_id,
                        options.position_id = $scope.position_id,
                        options.nameSearch = $scope.search.name,
                        options.surnameSearch = $scope.search.surname,
                        options.lastnameSearch = $scope.search.lastname;
                        options.historic_position = $scope.search.historic_position;
                        options.person_type = $scope.typePersonSelected.checked;
                        options.save = false;

                        $http({
                            method: 'get',
                            url: (window as any).CONFIG.api_url + 'Notifications/SearchPersonsEmails',
                            params: options
                        }).then(function (results, status, headers, config) {
                            var data = results.data.rows;
                            var personsIds = [];
                            angular.forEach(data, function (dataR) {
                                if (personsIds.indexOf(dataR.id) < 0) {
                                    personsIds.push(dataR.id);
                                }
                            });
                            //Obtenemos sus im�genes
                            if (personsIds.length > 0) {
                                $http({
                                    method: 'post',
                                    url: (window as any).CONFIG.api_url + 'Persons/ImagesSmall',
                                    params: { ids: personsIds }
                                }).then(function (resultsImage, status, headers, config) {
                                    angular.forEach(data, function (person) {
                                        for (var i = 0; i < resultsImage.data.length; i++) {
                                            if (person.id == resultsImage.data[i].person_id) {
                                                person.photo = resultsImage.data[i].image_small;
                                                break;
                                            }
                                        }
                                    });
                                });
                            }
                            data.totalRows = results.data.totalRows;
                            $scope.totalRows = results.data.totalRows;
                            deferred.resolve(data);

                        });
                        return deferred.promise;

                    }
                }; //End gridoptions
            }
        };

        let callbackFunctionRowSelected = function (row, evt) {
            let addAll = row.length > 1;

            if (!addAll) {
                //buscamos si ya existe la persona a�adida
                var index = $scope.selectedRows.map(function (e) { return e; }).indexOf(row.entity.program_emails);
                if (index < 0) {
                    if (row.isSelected) {
                        logService.debug(row.entity.program_emails);
                        $scope.selectedRows.push(row.entity.program_emails);
                    } else {
                        logService.debug("lo quita?");
                        $scope.selectedRows.splice(index, 1);
                    }
                } else {
                    if (!row.isSelected) $scope.selectedRows.splice(index, 1);
                }

            } else {
                if (row[0].isSelected) {
                    //se ha seleccionado todo.
                    $scope.selectedRows = [];
                    for (let i = 0; i < $scope.gridGuestsOptions.gridApi.grid.options.totalItems; i++) { $scope.selectedRows.push(i); };
                } else {
                    $scope.selectedRows = [];
                }

            }
            logService.debug($scope.selectedRows);
        };

        let callbackFunctionItemChange = function () {
            $timeout(function () {
                for (var i = 0; i < $scope.gridGuestsOptions.data.length; i++) {
                    var row = $scope.gridGuestsOptions.data[i];
                    for (var select = 0; select < $scope.selectedRows.length; select++) {
                        let selected = $scope.selectedRows[select];
                        logService.debug(row.program_emails, selected);
                        if (row.program_emails == selected) {
                            $scope.gridGuestsOptions.gridApi.selection.toggleRowSelection(row);
                            break;
                        }
                    }
                }
            }, 350);//lo pongo as� porque sino falla la primera vez
        };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


        $scope.addGuests = function (continueOption) {

            var addAll = $scope.gridGuestsOptions.gridApi.selection.getSelectAllState();

            if (addAll) {
                let options: any = {};
                options.event_id = $scope.eventId,
                options.group_id = $scope.group_id,
                options.position_id = $scope.position_id,
                options.nameSearch = $scope.search.name,
                options.surnameSearch = $scope.search.surname,
                options.lastnameSearch = $scope.search.lastname;
                options.historic_position = $scope.search.historic_position;
                options.person_type = $scope.typePersonSelected.checked;
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + 'Notifications/SearchPersonsEmails',
                    params: options
                }).then(function (results, status, headers, config) {
                    var data = results.data.rows;
                    logService.debug(data)
                    var mailsSelected = new Array();
                    angular.forEach(data, function (row) {
                        logService.debug(row.program_emails);
                        mailsSelected.push(row.program_emails);
                        logService.debug(mailsSelected);
                    });

                    $uibModalInstance.close(mailsSelected);
                });
            } else {
                //Devolvemos el control al principal
                var mailsSelected = new Array();
                angular.forEach($scope.selectedRows, function (row) {
                    logService.debug(row);                    
                    mailsSelected.push(row);
                    logService.debug(mailsSelected);
                });
                
                $uibModalInstance.close(mailsSelected);
            }

        };//savePersonPosition

       

    }])

    

;